import React, { Fragment } from 'react'
import MEModal from '../../components/MEModal'
import { Button } from '@CommonComponents/buttons'
import { fixLmsId, uploadGradesToLms } from '../actions'
import { toast } from '@CommonComponents/toast'

export const canvasItems = [
  { id: 'canvas-heading', label: 'CANVAS', heading: true },
  { id: 'fix-lms-id', label: 'Fix Student Id', icon: 'fa-light fa-link' },
  { id: 'upload-grades', label: 'Upload Grades', icon: 'fa-light fa-upload' },
]

export const CanvasActions = ({ user_id, user_full_name, activeAction, close }) => {
  const submitFixLmsId = async () => {
    let data = { user_id: user_id }
    let resp = await fixLmsId(data)
    close()

    if (resp.status === 200) {
      toast.success('Successfully fixed Canvas ID')
    } else {
      let error = resp.message
      toast.error(`There was an error trying to fix Canvas ID. ${error}`)
    }
  }

  const submitUploadGrades = async () => {
    let data = { user_id: user_id }
    let resp = await uploadGradesToLms(data)
    close()

    if (resp.status === 204) {
      toast.info('Grades are being uploaded to Canvas, an offline task has been created')
    } else {
      toast.error(`There was an error trying to upload grades to Canvas.`)
    }
  }

  return (
    <Fragment>
      <MEModal
        show={activeAction === 'fix-lms-id'}
        close={close}
        title="Confirm"
      >
        <form onSubmit={e => e.preventDefault()}>
          <p>
            Attempt to resolve the Canvas Id for{' '}
            <i>{user_full_name}</i>?
          </p>
          <Button
            className="mt-3 me-btn me-btn-primary"
            type="button"
            onClick={submitFixLmsId}
          >
            Submit
          </Button>
        </form>
      </MEModal>
      <MEModal
        show={activeAction === 'upload-grades'}
        close={close}
        title="Confirm"
      >
        <form onSubmit={e => e.preventDefault()}>
          <p>
            Upload Activity grades to Canvas for{' '}
            <i>{user_full_name}</i>?
          </p>
          <Button
            className="mt-3 me-btn me-btn-primary"
            type="button"
            onClick={submitUploadGrades}
          >
            Submit
          </Button>
        </form>
      </MEModal>
    </Fragment>
  )
}
